// Main entry point for passover menu
import React from 'react';
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import PassoverMenu from './PassoverMenu';
import Confirmation from './Confirmation';
import SuccessPage from './SuccessPage';

const appName = document.getElementById("page-data").getAttribute("data-page-name");
const basename = appName ? `/${appName}` : "";

const root = createRoot(document.getElementById("passover-menu-container"));
root.render(
    <BrowserRouter basename={basename}>
        <Routes>
            <Route exact path="/" element={<PassoverMenu />} />
            <Route exact path="/confirmation" element={<Confirmation />} />
            <Route exact path="/success" element={<SuccessPage />} />
        </Routes>
    </BrowserRouter>
);
